import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router";
import { UserApi } from "../api-services/user.api";


export function Signup()
{
    const navigate = useNavigate();
    const user = UserApi();

    const [checked, setChecked] = useState(false);
    const [inputs, setInputs] = useState({});
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleChange = e => setChecked(e.target.checked)

    const handleInputs = ( event ) => {
        const { name , value } =  event.target ;
        setInputs( { ...inputs, [name] : value   } ) ;
    }

      
    const handleForm = async ( event ) => {

        event.preventDefault();
        // console.log(inputs);
        setStatus(0);
        setIsLoading(true);
        if(inputs.password === inputs.cpassword )
        {   
            try {
                const res = await user.insert(inputs);
                setIsLoading(false);
                if(res.data.success){
                    setStatus(1);
                    navigate('/validation-compte');
                }  
                else{ setStatus(-1); } 
            } catch (err) { 
                setIsLoading(false);
                setStatus(-1); 
            }
        }
        else {  
          setIsLoading(false);
          setStatus(-2) }
    } 

    return (

      <div className="">
        <div className="container pt-5 mb-5">
          <div className="row d-flex justify-content-center mt-4 px-2">
            <div className="col-lg-5 col-md-6 rounded-2">
              <form onSubmit={ handleForm } className="d-flex flex-column">

                <div className=" d-flex flex-column align-items-center gap-2 mb-4" > 
                    <img src="./favicon.png" alt="icon-agrospace" width="60" className=""/>
                    <span className="lead text-muted text-start"> Agrospace - Nouveau compte </span>
                </div>
                {
                  isLoading && (
                    <div className="d-flex justify-content-center align-items-center mb-3"> 
                      <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }

                {
                  status === -1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-danger">
                         Une erreur est survenue lors de la creation de votre compte, veuillez rééssayer s'il vous plaît.
                      </div>
                    </div>
                  )
                }

                {
                  status === -2 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-danger">
                        Erreur! Veuillez revoir votre mot de passe et la confirmation.
                      </div>
                    </div>
                  )
                }
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="text" name="fname" placeholder="Prénom" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="text" name="lname" placeholder="Nom" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <select className="w-100 border input py-3 px-3 text-muted rounded-2" name='sex' onChange={ handleInputs }>
                      <option value="" > Choisir sexe </option>
                      <option value="masculin" > Masculin </option>
                      <option value="feminin" > Féminin </option>
                    </select>
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-secondary"> +221 </span> 
                    <input type="number" name="phone" placeholder="Numéro de téléphone joignable" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="email" name="email" placeholder="Email" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } />
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="password" name="password" placeholder="Mot de passe" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="password" name="cpassword" placeholder="Confirmer mot de passe" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="checkbox" name="checker" checked={checked} className="border text-muted checkbox" onChange={ handleChange } required />
                    <span className="d-flex align-items-center gap-2 text-muted"> 
                      <span> J'accepte les  </span>  
                      <a href="/condition-utilisation" target="outlet" className="nav-link text-success"> conditions d'utilisation <i className="bi bi-arrow-right"></i></a>
                      <span> d'Agrospace </span> 
                      </span> 
                  </div>
                </div>
                {/* -------------------------------- */}   
                <button type="submit" disabled={!checked} className="btn btn-lg btn-success px-4 mt-2 mb-4"> Enregistrer </button> 
                   
              </form>
            </div>
          </div>
        </div>

        <div className="container-fluid p-4 bg-green-light">
          {/* Bottom Section */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3 border-top">
            <p className="mb-2 mb-md-0"> © 2025 Agrospace pack. Tout droit réservé. </p>
            <div className="d-flex flex-wrap gap-3">
              <p className="mb-2 mb-md-0"> powered by Xelkoom-AI </p>
            </div>
          </div>
          {/* Social Icons */}
          <div className="d-flex justify-content-center gap-3 my-3">
              <i className="bi bi-facebook fs-5"></i>
              <i className="bi bi-twitter-x fs-5"></i>
              <i className="bi bi-linkedin fs-5"></i>
              <i className="bi bi-github fs-5"></i>
              <i className="bi bi-instagram fs-5"></i>
              <i className="bi bi-youtube fs-5"></i>
          </div>
        </div>

      </div>
    )
}